export const P = {
  Student_View: 'Student.View',
  Student_Add: 'Student.Add',
  Student_Edit: 'Student.Edit',
  Student_Delete: 'Student.Delete',
  Student_Search: 'Student.Search',
  Student_ViewProgress: 'Student.ViewProgress',
  Student_ViewEnrolledCourses: 'Student.ViewEnrolledCourses',
  Student_Export: 'Student.Export',

  Course_View: 'Course.View',
  Course_Add: 'Course.Add',
  Course_Edit: 'Course.Edit',
  Course_Delete: 'Course.Delete',
  Course_Search: 'Course.Search',
  Course_ManageEnrollment: 'Course.ManageEnrollment',

  Unit_View: 'Unit.View',
  Unit_Add: 'Unit.Add',
  Unit_Edit: 'Unit.Edit',
  Unit_Delete: 'Unit.Delete',

  Lesson_View: 'Lesson.View',
  Lesson_Add: 'Lesson.Add',
  Lesson_Edit: 'Lesson.Edit',
  Lesson_Delete: 'Lesson.Delete',
  Lesson_ManageFiles: 'Lesson.ManageFiles',

  Quiz_View: 'Quiz.View',
  Quiz_Add: 'Quiz.Add',
  Quiz_Edit: 'Quiz.Edit',
  Quiz_Delete: 'Quiz.Delete',
  Quiz_ViewResults: 'Quiz.ViewResults',
  Quiz_Grade: 'Quiz.Grade',

  Assignment_View: 'Assignment.View',
  Assignment_Add: 'Assignment.Add',
  Assignment_Edit: 'Assignment.Edit',
  Assignment_Delete: 'Assignment.Delete',
  Assignment_Grade: 'Assignment.Grade',
  Assignment_ViewSubmissions: 'Assignment.ViewSubmissions',

  Community_View: 'Community.View',
  Community_Add: 'Community.Add',
  Community_Edit: 'Community.Edit',
  Community_Delete: 'Community.Delete',
  Community_Moderate: 'Community.Moderate',
  Community_Reply: 'Community.Reply',

  Order_View: 'Order.View',
  Order_Add: 'Order.Add',
  Order_Edit: 'Order.Edit',
  Order_Delete: 'Order.Delete',
  Order_Process: 'Order.Process',

  PromoCode_View: 'PromoCode.View',
  PromoCode_Add: 'PromoCode.Add',
  PromoCode_Edit: 'PromoCode.Edit',
  PromoCode_Delete: 'PromoCode.Delete',

  WalletCode_View: 'WalletCode.View',
  WalletCode_Add: 'WalletCode.Add',
  WalletCode_Edit: 'WalletCode.Edit',
  WalletCode_Delete: 'WalletCode.Delete',
  WalletCode_Generate: 'WalletCode.Generate',

  Book_View: 'Book.View',
  Book_Add: 'Book.Add',
  Book_Edit: 'Book.Edit',
  Book_Delete: 'Book.Delete',

  Session_View: 'Session.View',
  Session_Add: 'Session.Add',
  Session_Edit: 'Session.Edit',
  Session_Delete: 'Session.Delete',

  Curriculum_View: 'Curriculum.View',
  Curriculum_Add: 'Curriculum.Add',
  Curriculum_Edit: 'Curriculum.Edit',
  Curriculum_Delete: 'Curriculum.Delete',

  QuestionBank_View: 'QuestionBank.View',
  QuestionBank_Add: 'QuestionBank.Add',
  QuestionBank_Edit: 'QuestionBank.Edit',
  QuestionBank_Delete: 'QuestionBank.Delete',

  Transaction_View: 'Transaction.View',
  Transaction_Add: 'Transaction.Add',
  Transaction_Edit: 'Transaction.Edit',
  Transaction_Delete: 'Transaction.Delete',

  Contact_View: 'Contact.View',
  Contact_Reply: 'Contact.Reply',
  Contact_Delete: 'Contact.Delete',

  Statistics_View: 'Statistics.View',

  Reports_Generate: 'Reports.Generate',
  Reports_Export: 'Reports.Export',

  CourseCode_View: 'CourseCode.View',
  CourseCode_Add: 'CourseCode.Add',
  CourseCode_Delete: 'CourseCode.Delete',

  UnitCode_View: 'UnitCode.View',
  UnitCode_Add: 'UnitCode.Add',
  UnitCode_Delete: 'UnitCode.Delete',

  Tag_View: 'Tag.View',
  Tag_Add: 'Tag.Add',
  Tag_Edit: 'Tag.Edit',
  Tag_Delete: 'Tag.Delete',

  Settings_View: 'Settings.View',
  Settings_Edit: 'Settings.Edit',
} as const;

export type AssistantPrivilege = (typeof P)[keyof typeof P];

export interface PrivilegeModule {
  key: string;
  label: string;
  privileges: { value: AssistantPrivilege; label: string }[];
}

const actionLabel = (action: string): string => {
  const labels: Record<string, string> = {
    View: 'عرض القائمة',
    Add: 'إضافة',
    Edit: 'تعديل',
    Delete: 'حذف',
    Search: 'بحث',
    ViewProgress: 'عرض التقدم',
    ViewEnrolledCourses: 'عرض الباقات المسجل بها',
    Export: 'تصدير',
    ManageEnrollment: 'إدارة التسجيل',
    ManageFiles: 'إدارة الملفات',
    ViewResults: 'عرض النتائج',
    Grade: 'تصحيح',
    ViewSubmissions: 'عرض التسليمات',
    Moderate: 'مراجعة / موافقة',
    Reply: 'الرد',
    Process: 'معالجة',
    Generate: 'توليد',
    ViewSettings: 'عرض الإعدادات',
  };
  return labels[action] || action;
};

const moduleLabel = (module: string): string => {
  const labels: Record<string, string> = {
    Student: 'الطلاب',
    Course: 'الباقات',
    Unit: 'المحاضرات / الوحدات',
    Lesson: 'الدروس',
    Quiz: 'الاختبارات',
    Assignment: 'الواجبات',
    Community: 'المنتدى',
    Order: 'الطلبات',
    PromoCode: 'أكواد الخصم',
    WalletCode: 'أكواد المحفظة',
    Book: 'الكتب',
    Session: 'الحصص',
    Curriculum: 'المنهج',
    QuestionBank: 'بنك الأسئلة',
    Transaction: 'التحويلات',
    Contact: 'اتصل بنا',
    Statistics: 'الإحصائيات',
    Reports: 'التقارير',
    CourseCode: 'أكواد الباقات',
    UnitCode: 'أكواد المحاضرات',
    Tag: 'الوسوم',
    Settings: 'الإعدادات',
  };
  return labels[module] || module;
};

export const PRIVILEGE_MODULES: PrivilegeModule[] = (() => {
  const grouped = new Map<string, { value: AssistantPrivilege; label: string }[]>();
  (Object.values(P) as AssistantPrivilege[]).forEach((value) => {
    const [module, action] = value.split('.');
    const list = grouped.get(module) || [];
    list.push({ value, label: actionLabel(action) });
    grouped.set(module, list);
  });
  return Array.from(grouped.entries()).map(([key, privileges]) => ({
    key,
    label: moduleLabel(key),
    privileges,
  }));
})();

export const ALL_ASSISTANT_PRIVILEGES: AssistantPrivilege[] = Object.values(P);

export const DEFAULT_ASSISTANT_PRIVILEGES: AssistantPrivilege[] = [
  P.Student_View,
  P.Student_Search,
  P.Student_ViewEnrolledCourses,
  P.Course_View,
  P.Course_Search,
  P.Unit_View,
  P.Lesson_View,
  P.Quiz_View,
  P.Quiz_ViewResults,
  P.Community_View,
  P.Order_View,
  P.Statistics_View,
];

export const PRIVILEGE_BY_MODULE: Record<string, AssistantPrivilege[]> = PRIVILEGE_MODULES.reduce(
  (acc, mod) => {
    acc[mod.key] = mod.privileges.map((p) => p.value);
    return acc;
  },
  {} as Record<string, AssistantPrivilege[]>
);

export interface RoutePrivilege {
  pathPrefix: string;
  privilege: string;
}

export const ROUTE_VIEW_PRIVILEGES: RoutePrivilege[] = [
  { pathPrefix: '/system-users', privilege: P.Settings_View },
  { pathPrefix: '/students', privilege: P.Student_View },
  { pathPrefix: '/courses', privilege: P.Course_View },
  { pathPrefix: '/lectures', privilege: P.Unit_View },
  { pathPrefix: '/books', privilege: P.Book_View },
  { pathPrefix: '/unit-codes', privilege: P.UnitCode_View },
  { pathPrefix: '/codes', privilege: P.CourseCode_View },
  { pathPrefix: '/wallet-codes', privilege: P.WalletCode_View },
  { pathPrefix: '/orders', privilege: P.Order_View },
  { pathPrefix: '/promo-codes', privilege: P.PromoCode_View },
  { pathPrefix: '/transactions', privilege: P.Transaction_View },
  { pathPrefix: '/contact-us', privilege: P.Contact_View },
  { pathPrefix: '/community', privilege: P.Community_View },
  { pathPrefix: '/question-bank', privilege: P.QuestionBank_View },
  { pathPrefix: '/sessions', privilege: P.Session_View },
  { pathPrefix: '/random-quiz', privilege: P.Quiz_View },
  { pathPrefix: '/assignment', privilege: P.Assignment_View },
];

export const FIRST_ALLOWED_ROUTES: { path: string; privilege: string }[] = [
  { path: '/', privilege: P.Statistics_View },
  { path: '/students', privilege: P.Student_View },
  { path: '/courses', privilege: P.Course_View },
  { path: '/community', privilege: P.Community_View },
  { path: '/lectures', privilege: P.Unit_View },
  { path: '/books', privilege: P.Book_View },
  { path: '/unit-codes', privilege: P.UnitCode_View },
  { path: '/codes', privilege: P.CourseCode_View },
  { path: '/wallet-codes', privilege: P.WalletCode_View },
  { path: '/promo-codes', privilege: P.PromoCode_View },
  { path: '/orders', privilege: P.Order_View },
  { path: '/transactions', privilege: P.Transaction_View },
  { path: '/contact-us', privilege: P.Contact_View },
  { path: '/sessions', privilege: P.Session_View },
  { path: '/question-bank', privilege: P.QuestionBank_View },
];

export function getRequiredPrivilegeForPath(pathname: string): string | null {
  const match = ROUTE_VIEW_PRIVILEGES.find(
    (r) => pathname === r.pathPrefix || pathname.startsWith(`${r.pathPrefix}/`)
  );
  return match?.privilege ?? null;
}

export function getFirstAllowedPath(hasPrivilege: (privilege: string) => boolean): string {
  const found = FIRST_ALLOWED_ROUTES.find((r) => hasPrivilege(r.privilege));
  return found?.path || '/';
}

export function getPrivilegeLabel(privilege: string): string {
  const [module, action] = privilege.split('.');
  return `${moduleLabel(module)} — ${actionLabel(action)}`;
}
